// extracted by mini-css-extract-plugin
export default {"wrap":"DeleteRoleDialog-wrap","cancelButton":"DeleteRoleDialog-cancelButton","deleteButton":"DeleteRoleDialog-deleteButton"};